/*
 * Highcharts Graph: https://www.highcharts.com/demo/highcharts
 * Supported Graphs: Bar, Pie
 */

import React, { useRef } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import SolidGauge from "highcharts/modules/solid-gauge";
import HighchartsMore from "highcharts/highcharts-more";
import Highcharts3d from "highcharts/highcharts-3d";
import VariablePie from "highcharts/modules/variable-pie";

import { GRAPH_TYPES } from "common/config";
import { GRAPHS } from "common/graphs";
import { COLORS } from "common/colors";

HighchartsMore(Highcharts);
SolidGauge(Highcharts);
Highcharts3d(Highcharts);
VariablePie(Highcharts);

interface cProps {
  width: string;
  type:
    | "column"
    | "pie"
    | "bar"
    | "solidgauge"
    | "stakedbar"
    | "line"
    | "area"
    | "columnrange";
  title: string;
  exportTitle: string;
  float?: "left" | "right";
  xAxis?: string[];
  yAxis?: number[];
  series?: any[];
  stacked?: boolean;
  colors?: string[];
  xAxisTitle?: string;
  yAxisTitle?: string;
  height?: number;
}

const HGraph = (props: any) => {
  const {
    width,
    type,
    stacked,
    title,
    exportTitle,
    float,
    xAxis,
    yAxis,
    series,
    colors,
    yAxisTitle,
    xAxisTitle,
    height,
    graphData,
  } = props;
  const chartRef: any = useRef(null);

  const getOptions = () => {
    switch (type) {
      case GRAPH_TYPES.COLUMN:
        return GRAPHS.getColumnGraph(
          title,
          xAxis,
          yAxis,
          xAxisTitle,
          yAxisTitle,
          exportTitle,
          height,
          stacked,
          series
        );
      case GRAPH_TYPES.PIE:
        return GRAPHS.getPieGraph(title, series, exportTitle, height);
      case GRAPH_TYPES.STACKED_BAR:
        return GRAPHS.getStackedBar(
          title,
          xAxis,
          yAxis,
          series,
          xAxisTitle,
          yAxisTitle,
          exportTitle,
          height
        );
      case GRAPH_TYPES.BAR:
        return GRAPHS.getBarGraph(
          title,
          xAxis,
          yAxis,
          xAxisTitle,
          yAxisTitle,
          exportTitle,
          colors,
          height
        );
      case GRAPH_TYPES.SOLIDGAUGE:
        return GRAPHS.getSolidGauge(title, series, title, height);
      case GRAPH_TYPES.LINE:
        return GRAPHS.getLineGraph(
          title,
          xAxis,
          series,
          exportTitle,
          xAxisTitle,
          yAxisTitle,
          height
        );
      case GRAPH_TYPES.AREA:
        return GRAPHS.getAreaGraph(
          title,
          xAxis,
          series,
          xAxisTitle,
          yAxisTitle,
          height
        );
      case GRAPH_TYPES.COLUMN_RANGE:
        return GRAPHS.getColumnRangeGraph(
          title,
          xAxis,
          series,
          xAxisTitle,
          yAxisTitle,
          exportTitle,
          height
        );
      default:
        break;
    }
  };

  let options: any = graphData;
  if (!options) {
    options = getOptions();
  }

  if (colors) {
    options.colors = colors;
  }

  console.log("options: ", options);

  return (
    <div
      className="graphBox"
      style={{
        width: width,
        flexDirection: "row",
        justifyContent: float === "right" ? "flex-end" : "flex-start",
        border: "none",
      }}
    >
      <div style={{ width: "100%", border: "none" }}>
        <HighchartsReact
          highcharts={Highcharts}
          options={options}
          ref={chartRef}
        />
      </div>
    </div>
  );
};

export default HGraph;
